import { LegalLayout } from "../../components/legal/LegalLayout";
import type { LegalSection } from "../../components/legal/LegalLayout";
import { DpoLink } from "../../components/legal/DpoLink";
import { usePageMeta } from "../../hooks/usePageMeta";
import { COMPANY } from "../../components/shared/Footer";
import content from "../../data/content.json";

const SECTIONS: LegalSection[] = [
  {
    title: "Escopo",
    body: <p>Esta política descreve como o Gepeto, software utilitário de geração de documentos, trata dados pessoais em conformidade com a Lei nº 13.709/2018 (LGPD).</p>,
  },
  {
    title: "Dados tratados e finalidade",
    body: <p>São tratados apenas os dados estritamente necessários à geração e ao envio da notificação (como nome, CPF, e-mail e informações do contrato), exclusivamente para essa finalidade.</p>,
  },
  {
    title: "Processamento efêmero e expurgo",
    body: (
      <>
        <p>Assumimos o compromisso estrito de expurgar os dados contratuais após o envio do documento. Não há retenção indevida nem reutilização para fins diversos.</p>
        <p>Poderão ser mantidos somente registros mínimos exigidos por obrigação legal ou para emissão de comprovantes, pelo prazo legalmente previsto.</p>
      </>
    ),
  },
  {
    title: "Compartilhamento",
    body: <p>Os dados não são vendidos nem compartilhados para fins comerciais. O compartilhamento limita-se ao necessário para a entrega do documento ao destinatário indicado pelo usuário.</p>,
  },
  {
    title: "Mensuração de anúncios (Google Ads)",
    body: <p data-testid="privacidade-google-ads">Utilizamos a tag do Google Ads, que pode gravar cookies de mensuração de conversão no seu navegador. Na confirmação do pagamento, enviamos ao Google apenas o número do protocolo e o valor pago; CPF, CNPJ, e-mail, nome ou qualquer outro dado pessoal informado no formulário nunca são enviados.</p>,
  },
  {
    title: "Direitos do titular",
    body: <p>Você pode solicitar confirmação de tratamento, acesso, correção, anonimização ou eliminação dos seus dados, nos termos do art. 18 da LGPD.</p>,
  },
  {
    title: "Encarregado (DPO) e controlador",
    body: <p data-testid="privacidade-controlador">Controlador: {COMPANY.razaoSocial} (nome fantasia {COMPANY.nomeFantasia}) — CNPJ {COMPANY.cnpj}. Endereço: {COMPANY.endereco}. Encarregado pelo tratamento de dados (DPO): <DpoLink testId="privacidade-dpo-email" />.</p>,
  },
];

const ZERO_RETENTION = (
  <aside data-testid="zero-retention-notice" className="mt-10 rounded-md border border-emerald-500/40 bg-emerald-500/5 p-5 text-sm leading-relaxed text-slate-200 sm:p-6 sm:text-base">
    <strong className="font-semibold text-emerald-400">{content.zeroRetention.label}</strong> {content.zeroRetention.text}
  </aside>
);

export default function PrivacidadePage() {
  usePageMeta(
    "Política de Privacidade | Gepeto",
    "Política de Privacidade do Gepeto: processamento efêmero, expurgo de dados contratuais após o envio e conformidade com a LGPD.",
  );
  return <LegalLayout testId="privacidade-page" eyebrow="LGPD" title="Política de Privacidade" updatedAt="setembro de 2026" sections={SECTIONS} highlight={ZERO_RETENTION} />;
}
